import React, { useMemo } from 'react'
import { Card, Col, Row } from 'antd'
import { useSelector } from 'react-redux'
import { rubricPersistSelectors } from '../../../../../store/selectors/rubric.persist.selectors'
import Steps from './steps/Steps'
import ImportFileStep from './steps/ImportFileStep'
import CalibrationStep from './steps/calibration/CalibrationStep'
import QuestionMatchingStep from './steps/question-matching/QuestionMatchingStep'
import QuestionReviewStep from './steps/question-review/QuestionReviewStep'
import { useParams } from 'react-router'
import DiscardButton from './steps/common/DiscardButton'

const ImportRubricSection = () => {
    const { token } = useParams()
    const currentStep = useSelector(rubricPersistSelectors.currentStep(token))

    const content = useMemo(() => {
        if (currentStep === 0) {
            return <ImportFileStep />
        } else if (currentStep === 1) {
            return <CalibrationStep />
        } else if (currentStep === 2) {
            return <QuestionMatchingStep />
        } else {
            return <QuestionReviewStep />
        }
    }, [currentStep])

    return (
        <Card title='Import Rubric' extra={<DiscardButton />}>
            <Row>
                <Col span={4}>
                    <Steps />
                </Col>
                <Col span={20}>{content}</Col>
            </Row>
        </Card>
    )
}

export default ImportRubricSection
